import * as React from 'react';
import './Footer.scss';
import { Container, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import AppButton from '../../components/AppButton';

export interface FooterStateProps {

}

export interface FooterDispatchProps {

}

export type FooterProps = FooterStateProps & FooterDispatchProps;

const Footer: React.FC<FooterProps> = (_) => {

    const t = useTranslations();

    const [policyOpen, setPolicyOpen] = React.useState(false);
    const toggle = () => setPolicyOpen(!policyOpen);

    return (
        <Container className="appFooter">
            <p>© {new Date().getFullYear()} Appointmint</p>
            <span>·</span>
            <AppButton size="sm" color="link" onClick={toggle}>{t(TK.privacyPolicy)}</AppButton>
            <span>·</span>
            <a href='https://help.appointmint.pt/'>{t(TK.helpAndFaq)}</a>
            <span>·</span>
            <a href="mailto:support@appointmint.pt" target="_top">support@appointmint.pt</a>

            <Modal size="lg" isOpen={policyOpen} toggle={toggle}>
                <ModalHeader toggle={toggle}>{t(TK.privacyPolicy)}</ModalHeader>
                <ModalBody>
                    <div dangerouslySetInnerHTML={{__html: t(TK.privacyPolicyContent)}}/>
                </ModalBody>
            </Modal>
        </Container>
    );
}

export default Footer;
